import { toAccessor } from '@studio/react-utils';
import type { ReactElement } from 'react';
import { useLeftTabPref } from './hooks.js';
import { Root } from './root.jsx';
import { Triggers } from './triggers.jsx';
import type { PlaceholderProps } from './types.js';

/** `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => {
  const tab = toAccessor(useLeftTabPref());

  return (
    <Root {...props} tab={tab}>
      <Triggers disabled />
    </Root>
  );
};
